import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import { Container, Select, MenuItem, Grid, Card, CardContent, Typography } from '@material-ui/core';
import Header from '../components/Header';
import { IRecibospago, IUsuario } from './interfaces';
import { AXIOS_OPTIONS, MAIN_API, MONTHS } from '../utils/constants';
import Axios from 'axios';
import moment from 'moment';
import Recibo from './../components/Recibo';
import { handleAxiosError, parseJwt } from '../utils/functions';

const Receipts = () => {
    const [recibos, setRecibos] = useState<Array<IRecibospago>>([]);
    const [tipoRecibo, setTipoRecibo] = useState<"trabajador" | "beneficiario" | undefined>();
    const [anios, setAnios] = useState<Array<number>>([]);
    const [anioSeleccionado, setAnioSeleccionado] = useState<number>(0);
    const [loading, setLoading] = useState(false);
    const usuario: IUsuario = parseJwt(localStorage.getItem("jwt") || "");

    useEffect(() => {
        const getRecibos = async () => {
            setLoading(true);
            const api = `${MAIN_API}/recibos/get/byRfc?rfc=${usuario.rfc}&tipo_persona=${tipoRecibo}`;
            try {
                const res = await Axios.get(api, AXIOS_OPTIONS);
                let recibos: Array<IRecibospago> = [];
                const anios: Array<number> = [];
                if (res.status === 200) {
                    recibos = res.data;
                    for (let i = 0; i < recibos.length; i++) {
                        const recibo = recibos[i];
                        const anio = moment(recibo.fechaPago).year();
                        if (anios.indexOf(anio) === -1) anios.push(anio);
                    }
                }
                setRecibos(recibos.filter(recibo => recibo.mostrar));
                setAnios(anios);
                setLoading(false);
            } catch (err) {
                await handleAxiosError(err);
            }
        }

        if (tipoRecibo) getRecibos();
    }, [usuario.rfc, tipoRecibo]);

    return (
        <section>
            <Helmet>
                <title>InfoISSET | Recibos de pago</title>
            </Helmet>
            <Navbar />
            <Container style={{ marginTop: 15 }}>
                <Header />
                <div style={{ display: "flex", justifyContent: "center", marginTop: 15 }}>
                    <Select
                        value={tipoRecibo || 0}
                        onChange={(e: React.ChangeEvent<{ value: any }>) => setTipoRecibo(e.target.value)}
                        variant="outlined"
                        label="Tipo de recibo"
                        style={{ width: 200, marginRight: 15 }}
                    >
                        <MenuItem value={0}>Seleccione un tipo de recibo</MenuItem>
                        <MenuItem value="trabajador">Trabajador</MenuItem>
                        <MenuItem value="beneficiario">Beneficiario</MenuItem>
                    </Select>
                    {tipoRecibo ?
                        <Select
                            value={anioSeleccionado}
                            onChange={(e: React.ChangeEvent<{ value: any }>) => setAnioSeleccionado(e.target.value)}
                            variant="outlined"
                            defaultValue={0}
                            label="Año a consultar"
                            style={{ width: 200 }}>
                            <MenuItem value={0}>{loading ? "Cargando..." : "Seleccione un año"}</MenuItem>
                            {anios.map(anio => (
                                <MenuItem value={anio} key={anio}>{anio}</MenuItem>
                            ))}
                        </Select>
                        : null}
                </div>
                {anioSeleccionado ?
                    <Grid container spacing={3} style={{ marginTop: 15 }}>
                        {MONTHS.map(mes => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={mes.id}>
                                <Card>
                                    <CardContent>
                                        <Typography variant="h5">
                                            {mes.name}
                                        </Typography>
                                        {/* Si no existe ningún recibo */}
                                        {recibos.filter(recibo => moment(recibo.fechaPago).month() === mes.id - 1 && moment(recibo.fechaPago).year() === anioSeleccionado).length < 1 ? <Typography variant="body1" color="textSecondary">No se encontraron recibos</Typography> : null}
                                        {/* Si existen recibos de ese mes y de ese año */}
                                        {recibos.filter(recibo => moment(recibo.fechaPago).month() === mes.id - 1 && moment(recibo.fechaPago).year() === anioSeleccionado).map((recibo, index) => {
                                            return <Recibo
                                                key={recibo.idRecibo}
                                                title={`${recibo.periodo}`}
                                                recibo={recibo}
                                                style={{ marginTop: 15, textTransform: "uppercase" }}
                                            />
                                        })}
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                    : null}
            </Container>
        </section>
    );
};

export default Receipts;
